/* tslint:disable */
/* eslint-disable */
/* @relayHash 8e6bb952b190fafb084e8ea63e031e7a */

import { ConcreteRequest } from "relay-runtime";
export type FirmDesignProfileMediaMutationInput = {
    serviceId: string;
    profilePhotoId?: string | null;
    splashPhotoId?: string | null;
    clientMutationId?: string | null;
};
export type profileMediaMutationVariables = {
    input: FirmDesignProfileMediaMutationInput;
};
export type profileMediaMutationResponse = {
    readonly firmDesignProfileMediaMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly profilePhoto: string | null;
                readonly profilePhotoId: string | null;
                readonly splashPhoto: string | null;
                readonly splashPhotoId: string | null;
            } | null;
        } | null;
    } | null;
};
export type profileMediaMutation = {
    readonly response: profileMediaMutationResponse;
    readonly variables: profileMediaMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FirmDesignProfileMediaMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publicProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "profilePhoto",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "profilePhotoId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "splashPhoto",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "splashPhotoId",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileMediaMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileMediaMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileMediaMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileMediaMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileMediaMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileMediaMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileMediaMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileMediaMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '87a3b2d8897a19074644a0a651774bb0';
export default node;
